module.exports = __webpack_public_path__ + "img/ly.fbdcdf45.svg";